import { createSelector } from "@reduxjs/toolkit";
export const selectSearchExecutionRoot = (state) => state.searchExecution;
export const selectSearchExecutionState = createSelector(selectSearchExecutionRoot, (state) => state.executionState);
export const selectJobIds = createSelector(selectSearchExecutionRoot, (state) => state.jobIds);
export const selectSearchTypesToSearch = createSelector(
  selectSearchExecutionRoot,
  (state) => state.searchTypesToSearch
);
export const selectSearchExecutionResult = createSelector(selectSearchExecutionRoot, (state) => state.result);
export const selectSearchJobId = createSelector(selectSearchExecutionResult, (result) => {
  var _a, _b;
  return (_b = (_a = result == null ? void 0 : result.result) == null ? void 0 : _a.result) == null ? void 0 : _b.id;
});
export const selectGlobalOverride = createSelector(
  selectSearchExecutionState,
  (executionState) => executionState.globalOverride
);
export const selectParameterBindings = createSelector(
  selectSearchExecutionState,
  (executionState) => executionState.parameterBindings
);
